/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesArenaGameSchema } from "./arenaGameSchema.ts";
import { goodLuckCoreEntitiesArenaResultSourceSchema } from "./arenaResultSourceSchema.ts";
import { goodLuckCoreEntitiesTournamentTeamSchema } from "./tournamentTeamSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesArenaGamePlacementSchema = z.object({
  id: z.string().nullish(),
  arenaGameId: z.string().nullish(),
  tournamentTeamId: z.string().nullish(),
  placement: z.optional(z.int()),
  pointsAwarded: z.optional(z.int()),
  get source() {
    return goodLuckCoreEntitiesArenaResultSourceSchema.optional();
  },
  createdAt: z.optional(z.iso.datetime()),
  get arenaGame() {
    return goodLuckCoreEntitiesArenaGameSchema.optional();
  },
  get tournamentTeam() {
    return goodLuckCoreEntitiesTournamentTeamSchema.optional();
  },
});
